import { render } from "./SaludCompleta.vue?vue&type=template&id=e5740f18&scoped=true"
import script from "./SaludCompleta.vue?vue&type=script&lang=js"
export * from "./SaludCompleta.vue?vue&type=script&lang=js"

import "./SaludCompleta.vue?vue&type=style&index=0&id=e5740f18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5740f18"]])

export default __exports__